import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSharedService} from '../../services/get-config-shared.service';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../reducers';
import {LoadLinkContractAction, LoadLinkContractUpdateCompanyNameAction} from '../../actions/contract-link';
import {LoadSubscriptionsLinkContractAction} from '../../actions/subscription-link-contract';
import * as moment from 'moment';
import * as _ from 'lodash';
import {ActivatedRoute, Router} from '@angular/router';
import {UpdateLinkContractAction} from '../../actions/link-contract-update';
import {ContractLinkForm} from '../../models/contract-link';
import {CommonField} from '../../models/common-field';
import * as fromCompanies from '../../../company/reducers';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ModalComponent} from '@storever/modal-confirmation';
import {SelectedItem} from '../../../order/models/order';
import * as fromRoot from '../../reducers';
import {ClearOneItemSubListAction, ClearSubListAction} from '../../actions/subscription-list';
import {CompanyClearAction} from '../../../company/actions/company-load';
import {Product} from '../../models/product';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {LoadMyCompaniesLinkContractAction} from '../../actions/companies-link-contract';
import {ConsoleLogger} from '@angular/compiler-cli/ngcc';

@Component({
  selector: 'storever-link-contract-modal',
  templateUrl: './link-contract-modal.component.html',
  styleUrls: ['./link-contract-modal.component.scss']
})
export class LinkContractModalComponent implements OnInit, OnDestroy {
  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  private sub$: Subscription;
  private subscriptions = [];
  @Input() contractName: string;
  @Input() contractUuid: string;
  @Input() companyName: string = null;
  @Input() companyUuid: string = null;
  productList: Product[];
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  @Input() productID: any;
  myForm: FormGroup;
  formConfig: GroupConfig;
  error = 'false';
  isBillingLinked: boolean;
  selectedSub: CommonField [] = [];
  product$: Observable<Product[]>;

  constructor(private getFormsService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private activatedRoute: ActivatedRoute,
              private bsModalRef: BsModalRef,
              private bsModalRefConfirmation: BsModalRef,
              private storeCompany: Store<fromCompanies.AppState>,
              private modalService: BsModalService,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private storeRoot: Store<fromRoot.AppState>,
              private store: Store<fromShared.AppState>) {
    this.product$ = this.storeRoot.pipe(select(fromRoot.selectors.getProducts))
    this.product$.subscribe(product => {if (product) {this.productList = product} });
  }
  get isEdit(): boolean {
    if (this.activatedRoute.snapshot.routeConfig) {
      return this.activatedRoute.snapshot.routeConfig.path === 'detail/:contractId'
    } else {
      return false
    }
  }
  private  get isAnomalies(): boolean {
    if (this.router) {
      if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
        return true;
      }
      else if (this.activatedRoute.snapshot.fragment === 'Subscription') {
        return true;
      }
      else if (this.selectedItem && this.selectedItem.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }

  }

  ngOnInit(): void {
    this.getSelectItemsInfo();

    if (this.isAnomalies) {
      if (this.router.url.split('?')[0].split('/')[1] !== 'anomalies') {
        this.formConfig = this.getConfigSharedService.getLinkContractOptionnelCompany();
      } else {
          this.formConfig = this.getConfigSharedService.getLinkContractAnomalies();
        }
    } else {
      this.formConfig = this.getConfigSharedService.getLinkContract();
    }
    if (this.router.url.split('?')[0].split('/')[2] === 'contracts' && this.selectedItem && this.selectedItem.length === 0
      &&   this.router.url.split('?')[0].split('/')[3] === 'detail') {
      this.formConfig = this.getConfigSharedService.getLinkContract();
    }
    if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
      this.store.dispatch(new CompanyClearAction());
    }
    // this.store.dispatch(new LoadMyCompaniesLinkContractAction());
    this.myForm = this.getFormsService.getLinkContract();
    this.myForm.get('subscriptionName').enable();
    this.myForm.get('subscriptionUuid').enable();
    this.getCompanyData();
    this.checkDateLogic();
    this.patchForm();
    this.disableForm();
    if (this.companyName && this.companyUuid && this.contractName && this.contractUuid) {
      this.getSubscriptionList(this.myForm.value);
      this.selectedSub = [];
      if (this.myForm.get('subscriptionName').disabled) {
        this.myForm.get('subscriptionName').enable();
      }
    } else {
      this.sub$ = this.myForm.get('contractUuid').valueChanges.pipe(debounceTime(500)).subscribe(value => {
        if (value) {
          this.getProductIdFromContractList(value);
        }
        if ( this.myForm.get('companyUuid').value &&
          this.myForm.get('startBilling').value &&
          value) {
          this.getSubscriptionList(this.myForm.value);
          if (!this.selectedOneItem && !this.selectedItem) {
            this.selectedSub = [];
          }
          if (this.myForm.get('subscriptionName').disabled) {
            this.myForm.get('subscriptionName').enable();
          }
        }

      });
      this.subscriptions.push(this.sub$);
    }
    this.sub$ =  this.myForm.get(['companyUuid']).valueChanges.pipe(debounceTime(500)).subscribe(value => {
     // if (value) {
        this.store.dispatch(new LoadLinkContractUpdateCompanyNameAction(value));
     // }
    });
    this.sub$ = this.myForm.valueChanges.pipe(debounceTime(500)).subscribe(value => {
      if ( value.startBilling  && this.myForm.get('contractName').disabled && !value.contractUuid) {
        this.store.dispatch(new LoadLinkContractUpdateCompanyNameAction(value.companyUuid));
        this.getContractList(value);
      }

      if ( value.startBilling) {
        this.getSubscriptionList(value);
      }
      if ( value.subscriptionName && value.subscriptionUuid) {
        this.updateSubscriptionSelectList(value);
      }
    });
    this.subscriptions.push(this.sub$);
    this.sub$ = this.myForm.get('onlyNotLinked').valueChanges.pipe(debounceTime(500)).subscribe(value => {
      this.getSubscriptionList(this.myForm.value);
    })
    this.subscriptions.push(this.sub$);
  }

  getProductIdFromContractList(contractUuid: string): void {
   this.sub$ = this.store.pipe(select(fromShared.selectors.getContractLink)).subscribe(data => {
     if ( data) {
       // tslint:disable-next-line:no-any
      const index =   _.findIndex(data, function(o: any): boolean { return o.contractUuid === contractUuid; });
      if (index !== -1) {
        this.productID = data[index].productID;
      }
     }
   });
   this.subscriptions.push(this.sub$);
  }

  getContractList( value: ContractLinkForm): void {
    this.store.dispatch(new LoadLinkContractAction({
      start:  moment(value.startBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      end: !value.endBilling ? '2099-12-31T00:00:00' : moment(value.endBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      productID: this.getProductId(),
    }));
    this.myForm.get('contractName').reset();
    this.sub$ = this.store.pipe(select(fromShared.selectors.getContractLink)).subscribe(data => {
      if ( data) {
        if (!this.myForm.get('contractName').value) {
          this.myForm.get('contractName').enable();
        } else if (this.myForm.get('subscriptionName').disabled) {
          this.myForm.get('subscriptionName').enable();
        }
      }
    })
    this.subscriptions.push(this.sub$);
  }
  getContractListWithProduct( value: ContractLinkForm , productID: string ): void {
    this.store.dispatch(new LoadLinkContractAction({
      start: moment(value.startBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      end: !value.endBilling ? '2099-12-31T00:00:00' : moment(value.endBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      productID: productID,
    }));
    this.myForm.get('contractName').reset();
  }
  getCompanyData(): void {
    if (!this.companyName) {
      this.sub$ = this.storeCompany.pipe(select(fromCompanies.selectors.getCompany)).subscribe(data => {
        if (data) {
          this.companyName =  data.name;
          this.companyUuid =  data.uuid;
        }
      });
      this.subscriptions.push(this.sub$);
    }
  }

  getSubscriptionList( value: ContractLinkForm): void {
    if (value.startBilling ) {
    this.store.dispatch(new LoadSubscriptionsLinkContractAction({
      start:  moment(value.startBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      end: !value.endBilling ? '2099-12-31T00:00:00' : moment(value.endBilling).format('YYYY-MM-DD[T]HH:mm:ss'),
      productID: this.productID,
      onlyNotLinked: '' + value.onlyNotLinked,
    }));
    this.sub$ = this.store.pipe(select(fromShared.selectors.getSubscriptionsLinkContract)).subscribe(data => {
      if ( data) {
        if (this.myForm.get('subscriptionName').disabled && !this.myForm.get('subscriptionName').value) {
          this.myForm.get('subscriptionName').enable();
        }
      }
    });
    this.subscriptions.push(this.sub$);
    }

  }

  updateSubscriptionSelectList( value: ContractLinkForm): void {
    // tslint:disable-next-line:no-any
    if (_.findIndex(this.selectedSub, function(o: any): any { return o.uuid === value.subscriptionUuid }) === -1) {
      this.selectedSub.push({name: value.subscriptionName , uuid: value.subscriptionUuid  });
      if (value.isBillingLinked) {
        this.isBillingLinked = true;
      }
    }
    this.myForm.patchValue({
      subscriptionName: null,
      subscriptionUuid: null,
    })
  }

  send(value: ContractLinkForm): void {
    if (!value.endBilling || value.endBilling === 'Invalid date') {
      value.endBilling = '2099-12-31'
    }
    if ( value.companyName === null ) {
      value.isActualCompanyLink = true;
    }
    if ( this.isBillingLinked) {
      // if (this.staticModal) {
      //   this.staticModal.hide();
      // } else {
      //   this.bsModalRef.hide();
      // }
      const initialState = {
        title: 'CONFIRMATION',
        message: 'Some of the selected subscriptions are already linked to a contract and company, Are you sure that you want to update the billing date in case of conflicts for these subscriptions ?',
        variable: null,
        deleteBtn: false,
        hideBtnOk: true
      };
      this.bsModalRefConfirmation = this.modalService.show(ModalComponent, {initialState});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe((modal) => {
        if (this.bsModalRefConfirmation.content.isConfirmed && this.selectedSub.length > 0) {
          this.store.dispatch(new UpdateLinkContractAction({ form: value, subList: this.selectedSub }));
          this.myForm.get('startBilling').reset();
          // this.myForm.reset();
          this.selectedSub = [];
          if (this.staticModal) {
            this.staticModal.hide();
          } else {
            this.bsModalRef.hide();
          }
        }
        if (!this.bsModalRefConfirmation.content.isConfirmed && this.selectedSub.length > 0) {
            this.myForm.get('startBilling').reset();
            // this.myForm.reset();
            this.selectedSub = [];
            if (this.staticModal) {
              this.staticModal.hide();
            } else {
              this.bsModalRef.hide();
            }

          }
      });
      this.subscriptions.push(this.sub$);
    }
    else {
      this.store.dispatch(new UpdateLinkContractAction({form: value , subList: this.selectedSub }));
      this.close();
    }
   // this.storeCompany.dispatch(new ClearSubListAction());
    this.storeCompany.dispatch(new ClearOneItemSubListAction());
  }

  open(): void {
    if (this.isAnomalies) {
      this.formConfig = this.getConfigSharedService.getLinkContractAnomalies();
    } else {
      this.formConfig = this.getConfigSharedService.getLinkContract();
    }
    if (this.router.url.split('?')[0].split('/')[2] === 'contracts' && this.selectedItem && this.selectedItem.length === 0
      &&   this.router.url.split('?')[0].split('/')[3] === 'detail') {
      this.formConfig = this.getConfigSharedService.getLinkContract();
    }
    this.myForm.patchValue({onlyNotLinked: true });
    this.staticModal.show();
  }

  close(): void {
    this.myForm.get('startBilling').reset();
   // this.myForm.reset();
    this.selectedSub = [];
    this.isBillingLinked = null;
    if (this.staticModal) {
      this.staticModal.hide();
    } else {
      this.bsModalRef.hide();
    }
  }

  remove(index: number): void {
    if (index > -1) {
      this.selectedSub.splice(index, 1);
    }
  }
  checkProductType(): boolean {
    let isProductSame = true;
    if (this.selectedItem && this.selectedItem.length > 0) {
    const productTmp = this.selectedItem[0].productName;
    for (let i = 0; i < this.selectedItem.length; ++i) {
       if (this.selectedItem[i].productName !==  productTmp) {
         isProductSame = false;
       }
    }
    }
    return isProductSame;
  }

  removeSubscription(index: number): void {
    if (this.selectedItem.length > 1) {
      let selectedItemTemp;
      selectedItemTemp = _.cloneDeep(this.selectedItem);
      if (index > -1) {
        selectedItemTemp.splice(index, 1);
      }
      this.selectedItem = selectedItemTemp;
      this.selectedSub = selectedItemTemp;
      this.getContractListWithProduct(this.myForm.value , this.getProductId())
    }

  }

  patchForm(): void {
    this.myForm.patchValue({
      startBilling : this.selectedOneItem ?  moment(this.selectedOneItem.deliveryDate).format('YYYY-MM-DD') : null,
      companyName: this.companyName,
      companyUuid: this.companyUuid,
      contractName: this.contractName,
      contractUuid: this.contractUuid,
      onlyNotLinked: true,
    });
  }

  disableForm(): void {
    if (this.myForm.get('companyName').value && !this.isAnomalies) {
      this.myForm.get('companyName').disable();
    }
    this.myForm.get('contractName').disable();
    this.myForm.get('subscriptionName').disable();
  }

  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.myForm.get('startBilling').reset();
    this.selectedSub = [];
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    // REMOVED because this code is causing 404 error sometimes and gives error when navigating outside contract / company details.
    // PLUS: refresh has non sense here
    // console.log('destroy link contract modal', this.router.url);
    // if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
    //   this.store.dispatch(new LoadSubAnomalyListAction());
    // } else if (this.router.url.split('?')[0].split('/')[1] === 'detail') {
    //   // Prevent refresh list out of context - destroy is called wether the modal was open or not when leaving contract detail page
    //   console.log('dispatch load subscriptions');
    //   this.store.dispatch(new LoadSubListAction());
    // }
    this.storeCompany.dispatch(new LoadMyCompaniesLinkContractAction());
    this.storeCompany.dispatch(new ClearOneItemSubListAction());
   // this.store.dispatch(new  ClearSubListAction());
    this.contractName = null;
    this.contractUuid = null;
    this.companyName = null;
    this.companyUuid = null;
    this.selectedSub = [];
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }
  checkDateLogic(): void {
    this.sub$ = this.myForm.valueChanges.subscribe((data) => {
      if (data.startBilling !== 'Invalid date' && data.endBilling !== 'Invalid date') {
        this.error = null;
        if (data.startBilling && data.endBilling && !moment(data.startBilling).isBefore(data.endBilling)) {
          this.error = 'End date must be bigger than the start date';
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }
  getSelectItemsInfo(): void {
    this.selectedItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedSub = [];
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
           this.selectedSub.push({name: this.selectedItem[j].name , uuid: this.selectedItem[j].uuid  });
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedSub.push({name: data.name , uuid: data.uuid  });
      }

    });
    this.subscriptions.push(this.sub$);
  }
  // tslint:disable-next-line:no-any
  getProductId(): any {
    if (this.selectedOneItem) {
     return this.selectedOneItem.productId ? this.selectedOneItem.productId : this.getProductIdStore(this.selectedOneItem.productName);

    } else if (this.selectedItem && this.selectedItem.length > 0 && this.selectedItem[this.selectedItem.length - 1]) {
        return this.selectedItem[this.selectedItem.length - 1].productId ?
          this.selectedItem[this.selectedItem.length - 1].productId : this.getProductIdStore(this.selectedItem[this.selectedItem.length - 1].productName);
    }
    return null;
  }

  // tslint:disable-next-line:no-any
  getProductIdStore(name: string): any {
    if (this.productList) {
      // tslint:disable-next-line:typedef
      const currentProduct = _.filter(this.productList, function (o) {
        return o.name === name;
      })
      return currentProduct[0].id ;
    }
  }
}
